module.exports = __webpack_public_path__ + "static/media/plus.c373e9f5.svg";